/**
 * Bandito: beden tablosu modalı (snippets/size-chart.liquid).
 *
 * İki iş yapıyor:
 *   1) Sekmeler — "cm Ölçüleri" (Beden/Göğüs/Bel) ve "Uluslararası Beden"
 *      (TR/EU/UK/US). Mobilde yedi sütun ekrana sığmadığı için Bel sağda
 *      kalıyor ve kaydırma ipucu olmadan görünmüyordu; tablo ikiye bölündü.
 *   2) Seçili beden satırını vurgulama — müşteri hangi satıra bakacağını
 *      aramasın. Beden, ürün sayfasındaki varyant seçicisinden okunuyor ve
 *      seçim değişince güncelleniyor.
 */

const KAP = '.size-chart';

/** @param {Element} kap @param {'cm'|'intl'} hedef */
function sekmeSec(kap, hedef) {
  for (const dugme of kap.querySelectorAll('.size-chart__tabs button')) {
    const etkin = dugme.dataset.hedef === hedef;
    dugme.setAttribute('aria-selected', String(etkin));
    const tablo = kap.querySelector(`#${dugme.getAttribute('aria-controls')}`);
    tablo?.toggleAttribute('hidden', !etkin);
  }
}

/**
 * Ürün sayfasında seçili beden. Beden fieldset'i variant-main-picker.liquid'de
 * data-size-required ile işaretleniyor.
 * @returns {string}
 */
function seciliBeden() {
  const secili = /** @type {HTMLInputElement | null} */ (
    document.querySelector('fieldset[data-size-required] input[type="radio"]:checked')
  );
  return secili?.value?.trim() ?? '';
}

/** Karşılaştırma için sadeleştirir: "Size 1 (36-38)" → "SIZE1(36-38)". */
function sadelestir(metin) {
  return metin.toLocaleUpperCase('tr-TR').replace(/\s+/g, '');
}

/** @param {Element} kap */
function seciliyiIsaretle(kap) {
  const beden = seciliBeden();
  const anahtar = sadelestir(beden);
  let bulundu = '';

  for (const satir of kap.querySelectorAll('.size-chart__table tr[data-beden]')) {
    const eslesti = anahtar !== '' && sadelestir(satir.dataset.beden ?? '') === anahtar;
    satir.toggleAttribute('data-secili', eslesti);
    if (eslesti) bulundu = satir.dataset.beden ?? '';
  }

  // İpucu metni yalnızca gerçekten eşleşme varken beden adını anıyor:
  // ürün bedenleri tablodakilerle her zaman aynı adlandırmada değil
  // (ör. "S/M" beden tablosunda karşılığı olmayabiliyor).
  const ipucu = kap.querySelector('[data-rol="ipucu"]');
  if (!ipucu) return;
  const oneri = 'If your measurements are between two sizes, we recommend choosing the larger size.';
  ipucu.textContent = bulundu ? `Your selected size: ${bulundu}. ${oneri}` : oneri;
}

/** @param {Element} kap */
function kur(kap) {
  if (kap.dataset.btHazir) return;
  kap.dataset.btHazir = '1';

  kap.querySelector('.size-chart__tabs')?.addEventListener('click', (olay) => {
    const dugme = olay.target instanceof Element ? olay.target.closest('button[data-hedef]') : null;
    if (dugme) sekmeSec(kap, /** @type {'cm'|'intl'} */ (dugme.dataset.hedef));
  });

  // Modal her açılışta güncellensin: beden arada değişmiş olabilir.
  kap.querySelector('.size-chart__open')?.addEventListener('click', () => seciliyiIsaretle(kap));
  seciliyiIsaretle(kap);

  // Dışına (karartılmış alana) dokununca kapansın. <dialog> için o alana
  // yapılan tıklamanın hedefi dialog'un kendisi oluyor; ama dialog'un iç
  // boşluğuna tıklamak da öyle. Bu yüzden hedef kontrolü yetmiyor, imlecin
  // gerçekten kutunun dışında olup olmadığına bakıyoruz.
  const dialog = /** @type {HTMLDialogElement | null} */ (kap.querySelector('.size-chart__dialog'));
  dialog?.addEventListener('click', (olay) => {
    if (olay.target !== dialog) return;
    const kutu = dialog.getBoundingClientRect();
    const disarida =
      olay.clientX < kutu.left ||
      olay.clientX > kutu.right ||
      olay.clientY < kutu.top ||
      olay.clientY > kutu.bottom;
    if (disarida) dialog.close();
  });
}

for (const kap of document.querySelectorAll(KAP)) kur(kap);

// Beden seçimi değişince (ve varyant değişiminde bölüm yeniden render
// edilince) vurgu güncel kalsın.
document.addEventListener('change', (olay) => {
  if (!(olay.target instanceof Element)) return;
  if (!olay.target.closest('fieldset[data-size-required]')) return;
  for (const kap of document.querySelectorAll(KAP)) seciliyiIsaretle(kap);
});

new MutationObserver(() => {
  for (const kap of document.querySelectorAll(KAP)) kur(kap);
}).observe(document.body, { childList: true, subtree: true });
